export default "__VITE_ASSET__Bzd7wlyd__"